export const apiField = 'use_default_block_capacities';
interface DefaultMinAndMaxField {
  type: string;
  apiField: string;
  label: string;
  id?: string;
  aria_label?: string;
}

const config: DefaultMinAndMaxField = {
    type: 'Checkbox',
    label: 'Use Default Min And Max Block Count',
    apiField,
    id:'useDefaultMinAndMaxBlockCount',
    aria_label: 'Use Default Min And Max Block Count selection'
}

export default config;
